import React, { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames/bind';

import detectMobileOS from 'utils/detectMobileOS';

import AppButton from '../AppButton';
import styles from './styles.pcss';
const cx = classNames.bind(styles);

class MyBeelineBanner extends Component {
  constructor(props) {
    super(props);

    this.state = {
      mobileOS: null,
    };
  }

  componentDidMount() {
    setTimeout(() => {
      this.setState({
        mobileOS: detectMobileOS(),
      });
    }, 0);
  }

  render() {
    const { mobileOS } = this.state;
    const { text, images } = this.props;

    if (!mobileOS) return null;

    return (
      <a
        className={cx('component')}
        href="https://mybeeline.onelink.me/3200640363/bb54d1ef"
        target="_blank"
        rel="noopener noreferrer"
      >
        <div className={cx('content')}>
          <div className={cx('text')}>
            {text}
          </div>

          {mobileOS === 'iOS' && <AppButton className="appStore" />}
          {mobileOS === 'Android' && <AppButton className="googlePlay" />}
        </div>
        <img
          className={cx('device')}
          src={images[mobileOS]}
          alt=""
        />
        <div className={cx('shadow')} />
      </a>
    );
  }
}

MyBeelineBanner.propTypes = {
  text: PropTypes.string,
  images: PropTypes.shape({
    iOS: PropTypes.string,
    Android: PropTypes.string,
  }),
};

export default MyBeelineBanner;
